import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableCell } from 'src/modules/sm-base/models/table-cell.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { CalendarEventStartRelativeTo } from '../../netgen/CalendarEventStartRelativeTo';
import { CalendarEventTemplate } from '../../netgen/CalendarEventTemplate';
import { ProjectPlanningService } from '../../services/project-planning.service';

@Component({
    selector: 'app-edit-calendar-event-templates',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCalendarEventTemplatesComponent extends AdminBaseListComponent<CalendarEventTemplate> {

    service = inject(ProjectPlanningService);

    definition = ProjectPlanningTools.definitionCalendarEventTemplate;

    async initAdditionalData(): Promise<void> {
        await this.service.getEventTypes();
    }
    
    getTable(): TableData {
        return this.app.tTable("entity.CalendarEventTemplate.fields", new TableData([
            new TableColumn("title", "", TableCellType.string, 50),
            new TableColumn("numTasks", this.app.t("entity.CalendarEventTemplate.other.numTasks"), TableCellType.int, 2, {
                align: "center"
            }), 
            new TableColumn("type", "", TableCellType.string, 15),
            new TableColumn("durationDays", "", TableCellType.int, 3),
            new TableColumn("workingTime", "", TableCellType.decimal, 5, { 
                numDecimalDigits: 2, 
                expandDecimalDigits: true 
            }),
            new TableColumn("startRelativeTo", "", TableCellType.string, 20),
            new TableColumn("isMilestone", "", TableCellType.bool, 1),
            new TableColumn("onlyWeekdays", "", TableCellType.bool, 1),
            new TableColumn("forStandalone", "", TableCellType.bool, 1)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, {
            title: o.title,
            numTasks: o.subTasks.length,
            type: this.service.getEventType(o.typeId)?.title ?? "",
            durationDays: o.durationDays,
            workingTime: o.workingTime,
            startRelativeTo: new TableCell(this.app.t("entity.CalendarEventTemplate.other.startRelativeDaysText", {
                days: o.startRelativeDays,
                startRelativeTo: CalendarEventStartRelativeTo.getDisplayName(o.startRelativeTo, this.app)
            }), { comparable: o.getStartDateComparable()}),
            isMilestone: o.isMilestone,
            onlyWeekdays: o.onlyWeekdays,
            forStandalone: o.forStandalone
        })), ["startRelativeDays", "title", "type"]));
    }
}
